export default __webpack_public_path__ + "static/media/mastercard-ico.389d9200.svg";